export class AppConfig {
   // url: string = 'http://127.0.0.1:8202/api/';
   // urlAAD:string = 'http://127.0.0.1:8202/saml2/87567294-c7d4-4db5-9df5-b4431ad44f34/';

   // url: string = 'https://backyalipatrimonial.bitgob.com/api/';
   // urlAAD:string = 'https://backyalipatrimonial.bitgob.com/saml2/87567294-c7d4-4db5-9df5-b4431ad44f34/';
   // municipio: string = 'Bitgob';
   // ENTIDAD: string = '116';
   // CLAVE_ENTIDAD: string = '0';

   // url: string = 'https://backyalipatrimonial.hueypoxtla.gob.mx/api/';
   // urlAAD:string = 'https://backyalipatrimonial.hueypoxtla.gob.mx/saml2/187fe980-d4c1-4bda-9d1f-ef60ac5493ba/';
   // municipio: string = 'Hueypoxtla';
   // ENTIDAD: string = '116';
   // CLAVE_ENTIDAD: string = '0';

   url: string = 'https://backyalipatrimonial.chapultepec.gob.mx/api/';
   urlAAD:string = 'https://backyalipatrimonial.chapultepec.gob.mx/saml2/87567294-c7d4-4db5-9df5-b4431ad44f34/';
   municipio: string = 'Chapultepec';
   ENTIDAD: string = '071';
   CLAVE_ENTIDAD: string = '4';



}